import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "@/components/brand/Logo";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center p-6 text-center" data-testid="not-found-page">
      <Logo size={48} />
      <h1 className="mt-10 font-display text-7xl md:text-9xl font-extrabold text-worker leading-none">404</h1>
      <p className="mt-2 text-2xl font-display font-semibold text-worker">{t("notFound.title")}</p>
      <p className="mt-4 text-smoke text-lg max-w-md">{t("notFound.subtitle")}</p>
      <Link to="/" className="fx-btn fx-btn--primary mt-8">{t("notFound.back")}</Link>
    </div>
  );
}
